import React from 'react';
import {
    IonContent,
    IonItem,
    IonLabel,
    IonList,
    IonPage} from '@ionic/react';
import Header from '../../components/header/Header';


const ThemePage = () => {
    return (
        <IonPage>
            <Header title="Thema pagina" showBackButton={true} showDateToolbar={true}/>

            <IonContent>
                <IonList>
                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>

                    <IonItem routerLink="/theme/detail">
                        <IonLabel>
                            <h2>Lorem ipsum dolor site amet</h2>
                            <p>2020-06-04 | Lorem</p>
                        </IonLabel>
                    </IonItem>
                </IonList>
            </IonContent>
        </IonPage>
    );
};

export default ThemePage;
